// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-57f1d89b]{font-size:2.25rem;font-size:2.7vmax;padding-top:30px}p[data-v-57f1d89b]{font-size:1.75rem;font-size:2.4vmax}.note[data-v-57f1d89b]{text-align:center}[data-v-57f1d89b] .h-stack{-ms-flex-pack:distribute;justify-content:space-around}", ""]);
// Exports
module.exports = exports;
